export default {"src":"/_next/static/media/targeted.2fcf701f.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};